module.exports = __webpack_public_path__ + "static/media/LogoNuestrosAutosGradient.af1d649d.svg";